// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20gJf","label":"styles_label__Wp5dz"};